import React from 'react';
import { CimmplePayDocLayout } from './CimmplePayDocLayout';
import { apiQuickReferenceMarkdown } from '../../../content/cimmplepay/api-quick-reference.md';

const ApiQuickReference: React.FC = () => {
  return (
    <CimmplePayDocLayout
      seoTitle="API Quick Reference | CimmplePay Docs"
      seoDescription="A high-signal list of CimmplePay endpoints for ERP integrations—auth, companies, employees, payroll lifecycle, outputs, and standard response codes."
      markdown={apiQuickReferenceMarkdown}
    />
  );
};

export default ApiQuickReference;
